import React from "react";
import PlanSummary from "../Plans/PlanSummary/PlanSummary";

const PlanSummaryWrapper = () => {
    return <PlanSummary/>
}

export default PlanSummaryWrapper;